import styled from 'styled-components';

const PortfolioListStyle = styled.div`
	margin-top: var(--titleToContent);

	.portfolioList {
		.portfolioItem {
			perspective: 1055px;
			margin-bottom: var(--sp8x);

			a {
				display: block;
			}

			/* base: mobile – simple 1‑column, but with mixed ratios */
			&:nth-child(6n - 4),
			&:nth-child(6n - 1) {
				.image_video_cont {
					.image_video {
						padding-top: 135%;
					}
				}
			}

			.image_video_cont {
				position: relative;
				margin-bottom: var(--sp2-5x);
				transform: rotateY(-70deg);
				opacity: 0.3;

				&.image_active {
					img {
						opacity: 0;
						transition: all 0.05s linear 1s;
					}
				}

				.image_video {
					padding-top: 75%;
				}

				video {
					position: absolute;
					z-index: 1;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					width: 100%;
					height: 100%;
					object-fit: cover;
					opacity: 0;
				}
			}

			.title,
			.description {
				margin-bottom: var(--sp1x);
			}

			&:last-child,
			&:nth-last-child(2) {
				margin-bottom: 0;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
			&.full {
				margin-left: calc(-1 * var(--containerPaddingLR));
				margin-right: calc(-1 * var(--containerPaddingLR));
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			--itemMarg: var(--sp4x);

			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;

			.portfolioItem {
				width: calc(50% - (var(--itemMarg) / 2));
				margin-bottom: var(--sp12x);

				&:nth-child(2n) {
					margin-left: calc(var(--itemMarg) / 2);
				}

				&:nth-child(2n-1) {
					margin-right: calc(var(--itemMarg) / 2);
				}

				&:nth-child(6n - 4),
				&:nth-child(6n - 1) {
					.image_video_cont {
						.image_video {
							padding-top: 135%;
						}
					}
				}

				&:nth-child(6n - 3),
				&:nth-child(6n - 1) {
					.image_video_cont {
						.image_video {
							margin-top: -61%;
						}
					}
				}

				/* &:nth-last-child(2) {
					margin-bottom: 0 !important;
				} */

				&.case-5 {
					&:nth-child(5) {
						.image_video_cont {
							.image_video {
								margin-top: 0 !important;
							}
						}
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			--maxWidth: 83%;

			max-width: var(--maxWidth);
			margin: 0 auto;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--maxWidth: 950px;
			--itemMarg: var(--sp9x);

			.image_video_cont {
				.image_video {
					margin-bottom: var(--sp3x);
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			.portfolioItem {
				margin-bottom: var(--sp15x);

				.image_video_cont {
					.image_video {
						margin-bottom: var(--sp4x);
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			--maxWidth: 79.3%;
			--itemMarg: var(--sp13x);

			.portfolioItem {
				margin-bottom: var(--sp20x);
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--maxWidth: 74.2%;

			.portfolioItem {
				margin-bottom: var(--sp25x);

				.image_video_cont {
					.image_video {
						margin-bottom: var(--sp5x);
					}
				}

				.title,
				.description {
					margin-bottom: var(--sp1x);
				}
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		&.not-padding {
			> .container {
				padding-left: 0 !important;
				padding-right: 0 !important;
			}
		}
	}
`;

export default PortfolioListStyle;
